'use strict';

import loaderTemplate from './views/playerLoader.hbs';
import youtubePlayerTemplate from './views/playerYouTube.hbs';
import livestreamPlayerTemplate from './views/playerLiveStream.hbs';
import ustreamPlayerTemplate from './views/playerUstream.hbs';
import featuredDetailsTemplate from './views/featuredDetails.hbs';
import buyDVDTemplate from './views/buyDVDButton.hbs';
import jQuery from 'jquery';
import cookie from './../../../vendor/jquery.cookie';
import ShowModel from './ShowModel.js';
import VideoModel from './VideoModel.js';
import Core from './../../Core/Core';
import ga from './../../../vendor/google-analytics';
import COVEVideoPlayer from './COVEVideoPlayer.js';
import ViralEmbed from './../../ViralEmbed/ViralEmbed';

/**
 * ShowPage video player
 */
var ShowPagePlayer = (function ($) {
  return function (options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
        MINDELAY: 250,
        VIDEO_RESIZE_DURATION: '0s'
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function () {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the window
      privateNS.$window = $(window);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create references to the featured spaces
      privateNS.$videoPlayerWrap = privateNS.$container.find('.video-player-wrap');
      privateNS.$featuredDetailsSpace = privateNS.$container.find('.episode-details');
      privateNS.$dvdButtonSpace = privateNS.$container.find('.dvd-button-wrapper');

      // Create a reference to the COVE video player iframe loader
      privateNS.$externalVideoPlayer = privateNS.$container.find('.cove-video-player');

      privateNS.player = new COVEVideoPlayer({
        container: privateNS.$videoPlayerWrap,
        showId: privateNS.options.showId,
        navigator: privateNS.options.navigator
      });

      // Create a viral embed for the show page
      privateNS.viralEmbed = new ViralEmbed({
        container: privateNS.$featuredDetailsSpace
      });

      // Create a reference to the video wrapper CSS object
      var stylesheets = document.styleSheets;

      // Loop through the loaded stylesheets
      for (var i = 0; i < stylesheets.length; i++) {

        // Find the main stylesheet with the video wrapper rule
        if (stylesheets[i].ownerNode && stylesheets[i].ownerNode.id === 'main-css-css') {

          try {

            // Get the rules from that stylesheet
            var rules = stylesheets[i].cssRules;

            // Loop through the rules of the stylesheet
            for (var j = 0; j < rules.length; j++) {

              // Find the rule for the video wrapper
              if (rules[j].selectorText === '.video-player-wrap') {

                // Store a reference to the video wrapper rule
                privateNS.videoPlayerWrapCSSRules = rules[j];

                // Store the initial value of the wrapper
                privateNS.videpPlayerWrapDefaultWidth = privateNS.videoPlayerWrapCSSRules.style.width;
              }
            }
          } catch (error) {
            // Catch errors here that are thrown from cross origin stylesheets
            // that we are not allowed to inspect
          }
        }
      }
      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Updates the UI for the featured section with data from the
     * featured player and featured details
     *
     * @param {object} [player]       Player information for the video
     * @param {object} [details]      Detail information for the video
     * @param {object} [dvdButton]    DVD information for the video
     */
    privateNS.update = function update(player, details, dvdButton) {

      // Update the featured player space with the determined method
      if (player) {
        privateNS.$videoPlayerWrap.html(player);
      }

      // Only update the details if new content is specified
      if (details) {

        // Now update the title and description of the featured content area
        privateNS.$featuredDetailsSpace.html(details);

        // Create a new Viral Embed
        this.viralEmbed = new ViralEmbed({
          container: privateNS.$featuredDetailsSpace
        });

        // Update the Buy DVD Button for the new content
        privateNS.$dvdButtonSpace.html(dvdButton || '');
      }
    };

    /**
     * Resets the size of the featured space to its default value
     */
    privateNS.resetFeaturedSpace = function resetFeaturedSpace() {

      // Update the CSS class rules of the video wrapper with the new width
      privateNS.videoPlayerWrapCSSRules.style.transition = '0s';
      privateNS.videoPlayerWrapCSSRules.style.width = privateNS.videpPlayerWrapDefaultWidth;
    };

    /**
     * Resize the featured video space to fit within in aspect ratio of
     * the browser
     */
    publicNS.resizeFeaturedSpace = function resizeFeaturedSpace() {

      // Only check for resizing if the video is actually playing
      if (privateNS.player !== null) {
        privateNS.player.getState().
          then(function (state) {

            // If the video is playing then run the resize check
            if (state === 'playing' || 'paused' || 'complete') {

              // First compute the aspect ratio of the window
              let maxSlantSize = 57.6, /** The full size of the slant at 1920 **/
                windowAspectRatio = ((privateNS.$window.height() - Core.header.getHeight() - Core.header.getSubHeaderHeight() - maxSlantSize) / privateNS.$window.width()) * 100,
                newWidth = 100;

              // If the window is less that 16:9 then do a resize
              if (windowAspectRatio < 56.25) {
                newWidth = (windowAspectRatio / 56.250) * 100;
              }

              // Update the CSS class rules of the video wrapper with the new width
              privateNS.videoPlayerWrapCSSRules.style.transition = privateNS.options.VIDEO_RESIZE_DURATION;
              privateNS.videoPlayerWrapCSSRules.style.width = newWidth + '%';
            }
          });
      }
    };

    /**
     * Handle loading the default show content into the featured space from
     * the server
     *
     * @return {Promise} Returns a promise that resolves or rejects based on the
     *                   loading being successful
     */
    publicNS.loadShow = function loadShow() {

      // Asynchronously ask the server for the show content so it can be loaded
      // as soon as possible.
      var showPromise = (new ShowModel()).
        fetch(privateNS.$container.attr('data-id') | 0);

      return privateNS.displayLoader().
        then(function (delay) {
          return showPromise;
        }).
        then(function (model) {

          // Extract the show data and social data from the load call
          var show = model.getContent(),
            social = model.getSocial();

          // Define a fail state in the case a template can not be chosen
          var playerTemplate = false;

          // Determine what player to load based on the streaming service
          // that was returned
          if (show.meta.stream_service === 'youtube') {

            // Simply define the YouTube player
            playerTemplate = youtubePlayerTemplate;
          } else if (show.meta.stream_service === 'livestream') {

            // Define the LiveStream player
            playerTemplate = livestreamPlayerTemplate;
          } else if (show.meta.stream_service === 'ustream') {

            // Define the Ustream player
            playerTemplate = ustreamPlayerTemplate;
          }

          // Make sure a template was chosen
          if (playerTemplate !== false) {

            // Create a date object for generating the air date display
            var currentDay = new Date();

            // Update the featured space with the new content
            privateNS.update(
              playerTemplate({
                autoplay: true,
                videoId: show.meta.stream_embed_code,
                liveStreamAccountId: show.meta.stream_account_id
              }),
              featuredDetailsTemplate({
                post_title: show.meta.stream_title,
                post_content: show.meta.stream_description,
                airdate: privateNS.formatAirdate(
                  currentDay.getFullYear() +
                  '-' +
                  (currentDay.getMonth() < 10 ? '0' + currentDay.getMonth() : currentDay.getMonth()) +
                  '-' +
                  (currentDay.getDate() < 10 ? '0' + currentDay.getDate() : currentDay.getDate())
                ),
                is_full_episode: true,
                social: $.extend(true, { displayEmbed: false }, social)
              })
            );

            // Return a null model as the livestream does not represent an
            // episode
            return null;
          }

          // Return a rejection if the show failed to load
          return $.Deferred().reject({
            msg: 'Failed to load show'
          }).promise();
        });
    };

    /**
     * Handle loading a video into the featured space from the server
     *
     * @param {int|VideoModel} video The id of the video to pull, or a
     *                               VideoModel to load
     *
     * @return {Promise} Returns a promise if there is a url hash and show id
     *                   to query on. If there is not, then return null
     */
    publicNS.loadVideo = function loadVideo(video) {

      // Define the video promise that will eventually resolve to a video model
      var videoPromise;

      // If a video id was passed in then look up the video on the server
      if (typeof video === 'number' || typeof video === 'string') {

        // Asynchronously ask the server for the video content so it can be
        // loaded as soon as possible.
        var videoFetchPromise = (new VideoModel()).fetch(video);

        // Attached a loader that will display the video after a delay
        videoPromise = privateNS.displayLoader().
          then(function (delay) {
            return videoFetchPromise;
          });
      } else {

        // Otherwise if a video model is passed in, immediately resolve to it
        videoPromise = $.Deferred().resolve(video);
      }

      return videoPromise.
        then(function (model) {
          privateNS.model = model;

          return model;
        }).
        then(function (model) {
          privateNS.player.load(model);
          privateNS.update(
            null,
            featuredDetailsTemplate({
              title: model.getContent().title,
              slug: model.getContent().slug,
              description_short: model.getContent().description_short,
              description_long: model.getContent().description_long,
              description_extended: model.getContent().description_extended,
              type: model.getContent().display_type,
              copyright: model.getContent().copyright,
              airdate: model.getContent().airdate,
              is_full_episode: model.getContent().display_type === 'Episode',
              tp_media_id: model.getContent().tp_media_id,
              is_public: model.getContent().is_public,
              social: {
                facebook: {
                  title: model.getContent().title,
                  content: model.getContent().description_long,
                  url: window.location.href
                },
                twitter: {
                  title: model.getContent().title,
                  content: model.getContent().description_short,
                  url: window.location.href
                },
                email: {
                  title: model.getContent().title,
                  content: model.getContent().description_long,
                  url: window.location.href
                }
              }
            }),
            buyDVDTemplate({
              buy_dvd_url: model.getContent().buy_dvd_url
            })
          );

          privateNS.bindPlayer();

          return model;
        });
    };

    /**
     * Unloads the existing page state by removing then bound event handlers,
     * and clearing the internal page state
     */
    publicNS.destroy = function destroy() {

      // Unbind all handlers from the video player
      privateNS.player.destroy();

      // Unbind the handlers of the viral embed
      privateNS.viralEmbed.destroy();

      // Reset the size of the featured space
      privateNS.resetFeaturedSpace();

      // Unbind the featured detail space
      privateNS.$featuredDetailsSpace.off();

      // Empty out the video details area
      privateNS.$featuredDetailsSpace.html('');
    };

    /**
     * Tears down the current video player and replaces it with a loader.
     *
     * @returns {Promise.<T>} A promise that will resolve after the loader is
     *                        finished with its delay. The promise will resolve
     *                        with the number of milliseconds that the delay
     *                        lasted
     */
    privateNS.displayLoader = function displayLoader() {

      // Create the loader deferred for chaining
      var loader = $.Deferred();

      // Add the loader display
      var loaderPromise = loader.promise().then(function displayLoaderGraphic() {

        // Destroy the current player and the related content
        publicNS.destroy();

        // Then display the loader and return
        return privateNS.$videoPlayerWrap.append(loaderTemplate());
      }).then(function delay() {

        // Create the deferred for the forced delay
        var delay = $.Deferred(),
          time = Date.now();

        // After the define delay, resolve the timeout
        setTimeout(function endDelay() {

          // Resolve with the actual amount of time spent in the delay
          delay.resolve(Date.now() - time);
        }, privateNS.options.MINDELAY);

        // Return the delay promise to chain off
        return delay.promise();
      });

      // Trigger the loading promise
      loader.resolve();

      // Resolve and return to the caller
      return loaderPromise;
    };

    /**
     * Called whenever the Cove Player switches in to the playing state
     */
    privateNS.onCovePlayerPlay = function onCovePlayerPlay() {

      // Whenever the video switches to play mode, check the aspect ratio to see
      // if it needs to be resized to fit the space
      publicNS.resizeFeaturedSpace();

      // Then scroll to the top of the player so that it is in full view
      Core.utils.goToElement(privateNS.$videoPlayerWrap.offset().top - Core.header.getHeight() - Core.header.getSubHeaderHeight());
    };

    /**
     * Called when the content of the embed element is copied
     */
    privateNS.onCopyEmbedCode = function onCopyEmbedCode() {
      ga('send', 'event', 'social', 'embed/show', window.location.href);
    };

    /**
     * Binds the events of the temporal UI elements of the player
     */
    privateNS.bindPlayer = function bindPlayer() {

      // Detect clicks into the iframe player
      privateNS.player.on(
        'play',
        privateNS.onCovePlayerPlay
      );

      // Attach the social share handler
      privateNS.$featuredDetailsSpace.on(
        'click',
        '.social-share',
        Core.utils.onSocialShare
      );

      // Attach the handler for the embed box display toggles
      privateNS.$featuredDetailsSpace.on(
        'click',
        '.embed-toggle, .embed-close',
        privateNS.onClickEmbedShareIcon
      );

      // Attach the handler for the embed box copy event
      privateNS.$featuredDetailsSpace.on(
        'copy',
        '.embed-code',
        privateNS.onCopyEmbedCode
      );
    };

    /**
     * Track clicks on either the call to action button. Store a cookie with
     * the users location so they can be redirected back if they complete the
     * sign in or activation process
     *
     * @param {jQuery} $event The triggering jQuery event
     */
    privateNS.trackPassportButtonInteraction = function trackPassportButtonInteraction($event) {

      // Extract the partial url from the hash
      var hash = location.hash.substr(1);

      // Determine the page that the user is currently on
      var currentPage = privateNS.$container.attr('data-post-name') + hash + '/';

      // Update the last known location of the user before they enter sign in land
      $.cookie('location_before_signin', location.protocol + '//' + location.host + '/' + currentPage, { path: '/' });

      // Determine the state of the user when they clicked the button
      var userState = Core.user.isSignedIn() ? 'Signed In' : 'Not Signed In';

      // Track the analytics event for the button click
      ga('send', 'event', 'Passport', 'Video Player Call to Action', userState);
    };

    /**
     * Handle clicks on the embed share icon and close button. Toggles the
     * display of the viral embed code snippet box
     *
     * @param $event
     */
    privateNS.onClickEmbedShareIcon = function onClickEmbedShareIcon($event) {

      $event.preventDefault();

      var $embedWrapper = privateNS.$featuredDetailsSpace.find('.embed-wrapper');

      // Toggle the display of the wrapper
      $embedWrapper.toggleClass('hide');

      // If the embed box is now displayed, focus the box and select the text
      if (!$embedWrapper.hasClass('hide')) {
        $embedWrapper.find('.embed-code').focus().select();
      }
    };

    /**
     * Takes a JS formatted datetime string and returns an object that
     * contains and appropriately formatted date, month, and year
     *
     * @param airdate string The datetime to format (YYYY-MM-DD HH:MM:SS)
     * @returns string An appropriately formatted date string
     */
    privateNS.formatAirdate = function formatAirdate(airdate) {

      // Not all browsers can successfully take an airdate string to a date
      // so a regular expression is used to extract the relevant information
      var dateParts = airdate.match(/(\d\d\d\d)\-(\d\d)\-(\d\d)/);

      // Transform the date string in to a native JS date object
      var date = new Date(dateParts[1], dateParts[2], dateParts[3]);

      // Return an appropriately formatted date pieces
      return date.getMonth() + '/' + date.getDate() + '/' + date.getFullYear().toString().slice(2);
    };

    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function attachHandlers() {

      // When the window resizes update the aspect ratio of the video player
      // so that it fits inside of the browser
      privateNS.$window.on(
        'resize',
        Core.utils.debounce(
          publicNS.resizeFeaturedSpace,
          250
        )
      );

      // Listen for clicks on the sign in / activate button so the user can
      // be directed back to their current location if they complete the
      // process
      privateNS.$videoPlayerWrap.on(
        'click',
        '.passport-interaction',
        privateNS.trackPassportButtonInteraction
      );

      // Bind the used events of the CovePlayer
      privateNS.bindPlayer();
    };

    return privateNS.init();
  };
})(jQuery);

export default ShowPagePlayer